import { atom } from "recoil";

export const globalErrorUIState = atom<string[]>({
  key: "globalErrorUIState",
  default: [],
});
